import { QuestionBase } from './question-base';

export class DisabledQuestion extends QuestionBase<string> {
  override controlType = 'disabled';
}


/*
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at https://angular.io/license
*/